

const tagWithId = (id, tags) => {
    return tags.filter((tag) => {
        return tag.uuid === id
    })[0]
}

export {tagWithId}